import { SettingsIcon } from '@ui/kit';
import { buttonCls, iconCls } from './atom.toggle-filter-button.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ToggleFilterButton(props) {
  return /*#__PURE__*/jsxs("button", {
    onClick: props.onClick,
    className: buttonCls,
    children: [/*#__PURE__*/jsx(SettingsIcon, {
      className: iconCls
    }), /*#__PURE__*/jsx("span", {
      children: "Filtr\xE9r forl\xF8b"
    })]
  });
}

export { ToggleFilterButton };
//# sourceMappingURL=atom.toggle-filter-button.js.map
